import { Model } from '@shared/models/Model';
import type { DataTableHeaders } from '@shared/types/Vuetify';
import type { IModel } from '@shared/types/Model';

export interface IPublicBlock extends IModel {
    transaction_id: string;
    inventory_id: string;
    first_carbon_value: string;
    carbon_block_tco2e: string;
    last_carbon_value: string;
    block_serial_code: string;
}

export class PublicBlock extends Model implements IPublicBlock {
    transaction_id!: string;
    inventory_id!: string;
    first_carbon_value!: string;
    carbon_block_tco2e!: string;
    last_carbon_value!: string;
    block_serial_code!: string;

    public constructor(o: IPublicBlock) {
        super(o);
        Object.assign(this, o);
    }

    public static override headers(): DataTableHeaders<IPublicBlock> {
        return [
            {
                title: 'Block Serial Code',
                key: 'block_serial_code',
                hasTooltip: () => ({
                    text: 'A ‘Block Serial Code’ is the unique identifier for a specific portion of sequestration units from a property’s carbon inventory, used to fulfill a transaction. <br/><br/>Depending on a company’s offset requirements, Block Serial Codes of varying sizes and from different properties can be created and added together to match exact transaction amounts.',
                }),
            },
            {
                title: 'Carbon (tCO2e)',
                key: 'carbon_block_tco2e',
                align: 'center',
                hasTooltip: () => ({
                    text: 'Measured in metric tons of CO₂ equivalent, this is the total amount of carbon offset involved in a specific portion of sequestration units used to fulfill a transaction.',
                }),
            },
            { title: 'Created At', key: 'created_at', date: true },
            { title: 'Updated At', key: 'updated_at', date: true },
        ];
    }
}
